import { Input } from "design-react-kit";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import UploadFile from "../../Components/UploadFile";
import  StateTranslate  from "../../Components/StateTranslate";
import LabelsLoader  from "../../Utility/labelsLoader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const d = new Date();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [serviceName, setServiceName] = useState();
  // const [rangesList, setRangesList] = useState([]);
  const [arrRanges1, setArrRanges1] = useState();
  const [arrRangesTemp1, setArrRangesTemp1] = useState([]);
  const [arrRanges2, setArrRanges2] = useState([]);
  const [arrRangesTemp2, setArrRangesTemp2] = useState([]);
  const [arrRangesFilter1, setArrRangesFilter1] = useState();
  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();

  const labels = LabelsLoader();

  const [stati, setStati] = useState([
    {"label":undefined,"value":""},
  {"label":"CREATE","value":"0"},
  {"label":"OPEN","value":"1"},
  {"label":"CLOSED","value":"2"},
  {"label":"ARCHIVED","value":"3"}]);
  const [statoTemp, setStatoTemp] = useState();





  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [loadedRanges, setLoadedRanges] = useState(false);
  const [filterRange, setFilterRange] = useState();
  const [uploadFile1, setUploadFile1] = useState();
  const [uploadFile2, setUploadFile2] = useState();
  const [uploadFile3, setUploadFile3] = useState();
  const [uploadFile4, setUploadFile4] = useState();
  const [uploadFile5, setUploadFile5] = useState();

  const [file, setFile] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);

  const [errorMessage, setErrorMessage] = useState(false);

  const [count, setCount] = useState(1);

  const [max, setMax] = useState(5);

  const addFile = async () => {
    if (count < max) {
      setCount(count + 1);
    }
  };

  let query = useQuery();

  useEffect(() => {
    if (apiToken) {
      setLoading(false);

      if (query.get("sessionId")) {
        Repo.getSessionByIdUser(apiToken, query.get("sessionId"))
          .then((response) => {
            setSession(response.data);

            


            setMax(5 - response.data.announcementFiles.length);
          })
          .catch((error) => {
            console.log(error);
          });
      }



      Repo.getRangesList(apiToken)
        .then((response) => {
          setArrRanges1(response.data);
          setArrRangesFilter1(response.data);
          setLoadedRanges(true);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getListaServizi(apiToken)
        .then((response) => {
        
          setServizi(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  useEffect(() => {
    if (session.bands && session.bands.length != 0 && arrRanges1) {
      setArrRanges2(session.bands);
      var rangesInit = arrRanges1.filter(function (obj) {
        return !session.bands.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(rangesInit);
    }
  }, [session, loadedRanges]);

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    let temp = {
      id: null,
      name: null,
      cost: null,
      serviceId: null,
      bandsId: null,
      state:null,
    };

    if (session.serviceId == null && session.service.id == null)
      passedValidation = false;

    if (session.name == null) passedValidation = false;
    if (session.codAccertamento == null) passedValidation = false;
    if (session.codCapitolo == null) passedValidation = false;
    if (session.nomeMyPay == null) passedValidation = false;

    console.log(temp);

    temp.bandsId = arrRanges2.map((x) => x.id);

    temp.id = session.id;
    temp.serviceId = session.service.id
      ? session.service.id
      : session.serviceId;
    temp.name = session.name;
    temp.codAccertamento = session.codAccertamento;
    temp.codCapitolo = session.codCapitolo;
    temp.nomeMyPay = session.nomeMyPay;
    temp.state =  parseInt(stati.find(o => o.label === session.state).value );

    temp["listBase64"] = [];

    for (let i = 1; i <= count; i++) {
      if (i == 1 && uploadFile1) {
        var splitBase64 = uploadFile1.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 2 && uploadFile2) {
        var splitBase64 = uploadFile2.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 3 && uploadFile3) {
        var splitBase64 = uploadFile3.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 4 && uploadFile4) {
        var splitBase64 = uploadFile4.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 5 && uploadFile5) {
        var splitBase64 = uploadFile5.split(",");
        temp["listBase64"].push(splitBase64[1]);
      }
    }

    setSession(temp);

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

 

  const postUpdateSession = () => {
    console.log(JSON.stringify(session));
    Repo.postUpdateSession(apiToken, JSON.stringify(session))
      .then((response) => {
        if (response.status == 200) {
        window.location.href =
            props.subfolder +
            "/lista_bandi/dettaglio_sessione?id=" +
            query.get("sessionId");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeRange = (event, percent, fixedcost) => {
    if (event) {
      let name = event.target.name;
      let id = event.target.id;
      let checked = event.target.checked;
      let value = event.target.value;

      switch (name) {
        case "checkBox1":
          if (checked) {
            setArrRangesTemp1((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp1.filter((item) => item.id !== id);

            setArrRangesTemp1(arr);

            break;
          }

        case "checkBox2":
          if (checked) {
            setArrRangesTemp2((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp2.filter((item) => item.id !== id);

            setArrRangesTemp2(arr);

            break;
          }

        default:
          break;
      }
    }
  };

  const transferRange = (bool) => {
    if (bool) {
      setArrRanges2(arrRanges2.concat(arrRangesTemp1));

      var arr = arrRanges1.filter(function (obj) {
        return !arrRangesTemp1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp1.filter(function (obj) {
        return !arrRanges1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges1(result);
      setArrRangesTemp1([]);
    } else {
      setArrRanges1(arrRanges1.concat(arrRangesTemp2));

      var arr = arrRanges2.filter(function (obj) {
        return !arrRangesTemp2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp2.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges2(result);
      setArrRangesTemp2([]);
    }
  };

  useEffect(() => {
    if (filterRange && arrRanges1) {
      var arr = arrRanges1.filter(function (obj) {
        return obj.name.toLowerCase().includes(filterRange.toLowerCase());
      });
      setArrRanges1(arr);
    } else if (arrRangesFilter1) {
      var arr2 = arrRangesFilter1.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(arr2);
    }
  }, [filterRange]);

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4">
          <div className="col-xs-12 col-md-5">
            <Input
              id="filterRange"
              label="Ricerca Fasce Isee"
              type="text"
              name="filterRange"
              value={filterRange ? filterRange : ""}
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>
        </div>
        <div className="it-transfer-block">
          <div className="row">
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper source">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1">
                      <span>FASCE ISEE DISPONIBILI</span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges1 &&
                      arrRanges1.length > 0 &&
                      arrRanges1.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox1"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp1 &&
                            arrRangesTemp1.length > 0 &&
                            arrRangesTemp1.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              <span>
                                {typeof x.percent != "object" && x.percent
                                  ? x.name +
                                    " (" +
                                    x.percent +
                                    "% di " +
                                    x.fixedCost +
                                    " €)"
                                  : x.name + " (" + x.fixedCost + " €)"}
                              </span>
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Button */}
            <div className="col-xs-12 col-md-2">
              <div className="it-transfer-buttons">
                {arrRangesTemp1 && arrRangesTemp1.length > 0 ? (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      onClick={() => transferRange(true)}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                ) : (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                )}

                {arrRangesTemp2 && arrRangesTemp2.length > 0 ? (
                  <>
                    <button
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer !important",
                      }}
                      className="backtransfer mt-2"
                      href="#"
                      aria-label="Sposta indietro"
                      onClick={() => transferRange(false)}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow left</span>
                  </>
                ) : (
                  <>
                    <button
                      className="backtransfer mt-2"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                  </>
                )}

                {/* <a className="reset" href="#" aria-label="Reset">
                  <svg className="icon">
                    <use href="/bootstrap-italia/dist/svg/sprite.svg#it-code-circle"></use>
                  </svg>
                </a>
                <span className="sr-only">Label for reset icon</span> */}
              </div>
            </div>
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper target">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1b">
                      <span>
                        <span>FASCE ISEE SELEZIONATE</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges2 &&
                      arrRanges2.length > 0 &&
                      arrRanges2.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox2"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp2 &&
                            arrRangesTemp2.length > 0 &&
                            arrRangesTemp2.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              {typeof x.percent != "object" && x.percent
                                ? x.name +
                                  " (" +
                                  x.percent +
                                  "% di " +
                                  x.fixedCost +
                                  " €)"
                                : x.name + " (" + x.fixedCost + " €)"}
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const returnVarName = (index) => {
    switch (index) {
      case 1:
        return setUploadFile1;
      case 2:
        return setUploadFile2;
      case 3:
        return setUploadFile3;
      case 4:
        return setUploadFile4;
      case 5:
        return setUploadFile5;

      default:
        break;
    }
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const fileListDownload = () => {
    return (
      <>
        {session.announcementFiles && session.announcementFiles.length > 0 && (
          <h5 className="mt-4">
            <b>Modulista caricata</b>
          </h5>
        )}

        {session.announcementFiles &&
          session.announcementFiles.length > 0 &&
          session.announcementFiles.map((x, index) => (
            <React.Fragment key={x.storageFileId}>
              <div className="row mt-2">
                <div className="col-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => showFile(x.storageFileId)}
                  >
                    Visualizza File {index + 1}
                  </button>
                </div>
                <div className="col-3  text-left">
                  <button
                    className="btn btn-xs btn-outline-danger"
                    onClick={() => deleteFile(x.storageFileId)}
                  >
                    <svg className="icon icon-danger">
                      <use xlinkHref={`${iconSprite}#it-delete`}></use>
                    </svg>
                  </button>
                </div>
              </div>
            </React.Fragment>
          ))}
      </>
    );
  };

  const deleteFile = (id) => {
    Repo.deleteFileOperator(apiToken, id)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showFile = (id) => {
    Repo.downloadFileOperator(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);

          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uploadFileAnnouncement = () => {
    return (
      <>
        <div className="row mb-4">
          <div className="col-12 text-right">
            <button className="btn btn-primary" onClick={() => addFile()}>
              <svg className="icon icon-white mr-2">
                <use href={`${iconSprite}#it-plus-circle`}></use>
              </svg>
              Aggiungi file
            </button>
          </div>
        </div>
        <div className="row ">
          {count &&
            [...Array(count)].map((x, index) => (
              <React.Fragment key={index}>
                <div className="col-12 col-lg-6 mb-5">
                  <UploadFile
                    setErrorMessage={setErrorMessage}
                    typeFile={[
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ]}
                    testoCaricamento="File caricato correttamente"
                    testoInterno="Seleziona file dal dispositivo"
                    testoTitolo=" "
                    handleFile={returnVarName(index + 1)}
                  ></UploadFile>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };


  return (
    <>
    { 
   
    console.log(session.state || '' )}
      <h1>Modifica bando</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Modifica il bando</p>
          </div>


      <div className="col-lg-12">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after roundedCustom">
            <div className="card-body p-5">
            <div className="row">
            <div className="col-lg-12">
                  <Input
                    id="title"
                    label="Titolo*"
                    type="text"
                    name="title"
                    value={session.name || session.name || ""}
                    onChange={(e) =>
                      setSession({ ...session, name: e.target.value })
                    }
                    {...(validation &&
                      !session.name && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
              </div>


              <div className="row">
                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Servizio"
                    clearText="Annulla"
                    defaultMenuIsOpen={false}
                    icon={false}
                    name="servizio"
                    id="servizio"
                    options={servizi}
                    onChange={(e) => {
                      setServizioTemp(e ? e.label : null);
                      setSession({ ...session, serviceId: e.value });
                      setServiceName();
                    }}
                    isClearable
                    isSearchable
                    value={session.serviceId || ""}
                    placeholder={
                      servizioTemp
                        ? servizioTemp
                        : serviceName
                        ? serviceName
                        : session.service
                        ? session.service.name
                        : "Seleziona servizio*"
                    }
                  />
                  {validation && !session.serviceId ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="bootstrap-select-wrapper col-lg-6">
                <Select
                aria-label="Stato bando"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="state"
                id="state"
                options={stati}
                onChange={(e) => {
                  setStatoTemp(e ? e.label : null);
                  setSession({ ...session, state: e.label });
                }}
          
               value={session.state || stati.find(o => o.label === session.state).value}
               placeholder={
                session.state
                  ? session.state
                  : "Seleziona stato*"
              }
              />
               
                  {validation && !session.state ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
               
                {/* <div className="col-lg-4">
                  <Input
                    id="cost"
                    label="Costo prestazione"
                    type="number"
                    name="cost"
                    value={session.cost ? session.cost : undefined}
                    onChange={(e) => setSession({ ...data, cost: e.target.value })}
                    infoText="Inserire il valore solo se non sono presenti fasce ISEE"
                  />
                </div> */}
              </div>
              <div className="row mt-4 mb-2">
                <div className="col-lg-4">
                  <Input
                    id="nomeMyPay"
                    label={labels.nomecampo1}
                    type="text"
                    name="nomeMyPay"
                    value={session.nomeMyPay || session.nomeMyPay || ""}
                    onChange={(e) =>
                      setSession({ ...session, nomeMyPay: e.target.value })
                    }
                    {...(validation &&
                      !session.nomeMyPay && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codAccertamento"
                    label="Codice Accertamento*"
                    type="text"
                    name="codAccertamento"
                    value={
                      session.codAccertamento || session.codAccertamento || ""
                    }
                    onChange={(e) =>
                      setSession({
                        ...session,
                        codAccertamento: e.target.value,
                      })
                    }
                    {...(validation &&
                      !session.codAccertamento && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codCapitolo"
                    label="Codice Capitolo*"
                    type="text"
                    name="codCapitolo"
                    value={session.codCapitolo || session.codCapitolo || ""}
                    onChange={(e) =>
                      setSession({ ...session, codCapitolo: e.target.value })
                    }
                    {...(validation &&
                      !session.codCapitolo && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
              </div>
              <h6>Fasce ISEE:</h6>
              {transferBlock()}

              {fileListDownload()}

              {max > 0 ? (
                <>
                  <h6 className="mt-5">
                    Modulistica (Massimo {max}
                    ):
                  </h6>
                  {uploadFileAnnouncement()}
                </>
              ) : (
                <span className="mt-5">
                  *Non è possibile caricare più di cinque allegati
                </span>
              )}

              <div className="row mt-2">
                <div className="col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => checkSession()}
                    title="Conferma"
                  >
                    Conferma
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo bando"
        body="Confermi di voler modificare il bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postUpdateSession()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default EditAnnouncement;
